import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripIcon } from 'lucide-react';
import { QuestionItem } from './QuestionItem';
import type { QuestionItemProps } from './types';

type SortableQuestionItemProps = QuestionItemProps & {
  /** Optional slot rendered before the grip handle (e.g. a checkbox) */
  checkboxSlot?: React.ReactNode;
};

export function SortableQuestionItem({ checkboxSlot, ...props }: SortableQuestionItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.question.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`flex items-start gap-2 ${isDragging ? 'opacity-50 shadow-xl z-50' : ''}`}
    >
      {/* Optional checkbox slot */}
      {checkboxSlot && (
        <div className="flex-shrink-0 pt-10">{checkboxSlot}</div>
      )}
      {/* Drag handle */}
      <div
        {...attributes}
        {...listeners}
        className="flex-shrink-0 mt-4 p-1 pt-6 text-gray-400 cursor-grab active:cursor-grabbing hover:text-gray-600"
        title="Drag to reorder"
      >
        <GripIcon className="h-5 w-5" />
      </div>
      <div className="flex-1 min-w-0">
        <QuestionItem {...props} dropMenuMobilePos='left' />
      </div>
    </div>
  );
}
